const createActionSet = (namespace, prefix) => {
  return {
    REQUEST: `${namespace}_${prefix}_REQUEST`,
    FAILURE: `${namespace}_${prefix}_FAILURE`,
    COMPLETE: `${namespace}_${prefix}_COMPLETE`,
  };
};

export default createActionSet;
